(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  const normalize = (value = '') => value.trim().replace(/\s+/g, ' ').toLowerCase();
  const toMenuKey = (value = '') =>
    normalize(value)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  const isUsableUrl = (value = '') => value && value !== '#' && value !== '/#' && !value.toLowerCase().startsWith('javascript:');

  function setExpanded(details, expanded) {
    const summary = details.querySelector(':scope > summary');
    if (expanded) {
      details.setAttribute('open', '');
      summary?.setAttribute('aria-expanded', 'true');
    } else {
      details.removeAttribute('open');
      summary?.setAttribute('aria-expanded', 'false');
    }
  }

  function closeSiblings(details) {
    const nav = details.closest('[data-oylin-mega-nav]');
    if (!nav) return;

    nav.querySelectorAll('[data-oylin-mega-item][open]').forEach((item) => {
      if (item !== details) setExpanded(item, false);
    });
  }

  function buildPromoMap() {
    const map = new Map();

    document.querySelectorAll('[data-oylin-mega-promo-source][data-menu-key]').forEach((source) => {
      const key = source.dataset.menuKey;
      const template = source.querySelector('[data-oylin-mega-promo-template]');
      if (!key || !template || map.has(key)) return;
      map.set(key, template);
    });

    return map;
  }

  function applyPromoOverrides() {
    const promoMap = buildPromoMap();

    document.querySelectorAll('[data-oylin-mega-item]').forEach((details) => {
      const panel = details.querySelector('[data-oylin-mega-panel]');
      const summary = details.querySelector(':scope > summary');
      if (!panel || !summary) return;

      let currentFeature = panel.querySelector('.oylin-mega-menu__feature');
      if (!currentFeature) return;

      if (!details._oylinFeatureFallback && currentFeature.dataset.oylinPromoRuntime !== 'true') {
        details._oylinFeatureFallback = currentFeature.cloneNode(true);
      }

      const key = toMenuKey(summary.textContent);
      const promoTemplate = promoMap.get(key);

      if (promoTemplate) {
        const fragment = promoTemplate.content.cloneNode(true);
        const promoFeature = fragment.querySelector('.oylin-mega-menu__feature');
        if (!promoFeature) return;

        promoFeature.dataset.oylinPromoRuntime = 'true';
        promoFeature.dataset.oylinPromoKey = key;
        currentFeature.replaceWith(promoFeature);
        return;
      }

      if (currentFeature.dataset.oylinPromoRuntime === 'true' && details._oylinFeatureFallback) {
        currentFeature.replaceWith(details._oylinFeatureFallback.cloneNode(true));
        bindFeatureSwaps(details);
      }
    });
  }

  function bindFeatureSwaps(details) {
    const panel = details.querySelector('[data-oylin-mega-panel]');
    const featureLink = panel?.querySelector('[data-oylin-feature-link]');
    const featureImage = panel?.querySelector('.oylin-mega-menu__image');
    const featureTitle = panel?.querySelector('[data-oylin-feature-title]');

    if (!panel || !featureLink || !featureTitle) return;

    panel.querySelectorAll('[data-oylin-feature-source]').forEach((source) => {
      if (source.dataset.oylinFeatureBound === 'true') return;
      source.dataset.oylinFeatureBound = 'true';

      const swap = () => {
        const image = source.dataset.featureImage;
        const title = source.dataset.featureTitle;
        const url = source.dataset.featureUrl;
        const alt = source.dataset.featureAlt || title || '';

        if (title) featureTitle.textContent = title;
        if (isUsableUrl(url)) featureLink.setAttribute('href', url);
        if (!featureImage || !image || featureImage.currentSrc === image || featureImage.src === image) return;

        featureImage.classList.add('is-swapping');
        window.setTimeout(() => {
          featureImage.removeAttribute('srcset');
          featureImage.removeAttribute('sizes');
          featureImage.src = image;
          featureImage.alt = alt;
          featureImage.addEventListener('load', () => featureImage.classList.remove('is-swapping'), { once: true });
          window.setTimeout(() => featureImage.classList.remove('is-swapping'), 280);
        }, 90);
      };

      source.addEventListener('pointerenter', swap);
      source.addEventListener('focus', swap);
    });
  }

  function bindItem(details) {
    if (details.dataset.oylinMegaBound === 'true') {
      bindFeatureSwaps(details);
      return;
    }
    details.dataset.oylinMegaBound = 'true';

    const summary = details.querySelector(':scope > summary');
    let closeTimer;

    const clearClose = () => window.clearTimeout(closeTimer);
    const open = () => {
      if (!desktopHover.matches) return;
      clearClose();
      closeSiblings(details);
      setExpanded(details, true);
    };
    const close = (delay = 150) => {
      if (!desktopHover.matches) return;
      clearClose();
      closeTimer = window.setTimeout(() => setExpanded(details, false), delay);
    };

    details.addEventListener('pointerenter', open);
    details.addEventListener('pointerleave', () => close());
    details.addEventListener('focusin', open);
    details.addEventListener('focusout', (event) => {
      if (!details.contains(event.relatedTarget)) close(80);
    });

    summary?.addEventListener('click', (event) => {
      if (!desktopHover.matches || event.detail === 0) return;
      const targetUrl = details.dataset.menuUrl;
      if (!isUsableUrl(targetUrl)) return;
      event.preventDefault();
      window.location.assign(targetUrl);
    });

    bindFeatureSwaps(details);
  }

  function buildResolvedLinkMap(root = document) {
    const map = new Map();
    const nav = root.querySelector('[data-oylin-mega-nav]') || document.querySelector('[data-oylin-mega-nav]');
    if (!nav) return map;

    nav.querySelectorAll('[data-oylin-mega-item]').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      const url = details.dataset.menuUrl;
      if (summary && isUsableUrl(url)) map.set(normalize(summary.textContent), url);
    });

    nav.querySelectorAll('a[href]').forEach((anchor) => {
      const href = anchor.getAttribute('href');
      if (!isUsableUrl(href)) return;
      const text = normalize(anchor.textContent.replace(/^view all\s+/i, '').replace(/\s*[↗→]\s*$/g, ''));
      if (text && !map.has(text)) map.set(text, href);
    });

    return map;
  }

  function repairDrawerNavigation(root = document) {
    const drawer = root.querySelector('#menu-drawer') || document.querySelector('#menu-drawer');
    if (!drawer) return;

    const linkMap = buildResolvedLinkMap(document);
    if (!linkMap.size) return;

    drawer.querySelectorAll('a[href]').forEach((anchor) => {
      const current = anchor.getAttribute('href') || '';
      if (isUsableUrl(current)) return;
      const resolved = linkMap.get(normalize(anchor.textContent));
      if (resolved) anchor.setAttribute('href', resolved);
    });

    drawer.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      const submenu = details.querySelector(':scope > .menu-drawer__submenu .menu-drawer__inner-submenu');
      if (!summary || !submenu || submenu.querySelector(':scope > .oylin-menu-drawer__overview')) return;

      const title = summary.textContent.replace(/[›⌄]/g, '').trim();
      const resolved = linkMap.get(normalize(title));
      if (!resolved) return;

      const overview = document.createElement('a');
      overview.className = 'oylin-menu-drawer__overview link focus-inset';
      overview.href = resolved;
      overview.innerHTML = `<span>View all ${title}</span><span aria-hidden="true">↗</span>`;

      const closeButton = submenu.querySelector(':scope > .menu-drawer__close-button');
      if (closeButton) closeButton.insertAdjacentElement('afterend', overview);
      else submenu.prepend(overview);
    });
  }

  function init(root = document) {
    applyPromoOverrides();
    root.querySelectorAll('[data-oylin-mega-item]').forEach(bindItem);
    document.querySelectorAll('[data-oylin-mega-item]').forEach(bindFeatureSwaps);
    repairDrawerNavigation(root);
  }

  function closeAll() {
    document.querySelectorAll('[data-oylin-mega-item][open]').forEach((details) => setExpanded(details, false));
  }

  document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', () => window.setTimeout(() => init(), 0));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  desktopHover.addEventListener?.('change', closeAll);
})();
